import React, { MutableRefObject, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './calendar/sass/styles.scss';
import { INumberedDocumentView, IProjectCalendarEvent } from '../../api-client/autogenerated';
import { useSelector } from 'react-redux';
import { getProjectId } from '../../features/project/selectors';
import { getAllProjectCalendarEvents } from '../../models/api/calendar';
import { ICalCalendar } from 'ical-generator';
import MonthDayCalendar from '../calendar/MonthDayCalendar';

interface DashboardUpcomingCalendarProps {
  soonestDueDocuments: INumberedDocumentView[];
  loading: boolean;
  calendarRef: MutableRefObject<any>;
  iCalendar: MutableRefObject<ICalCalendar>;
}

const useStyles = makeStyles({
  root: {
    fontFamily: 'Sans-Serif',
    font: 'Roboto',
    textTransform: 'capitalize',
    width: '100%',
    marginTop: 20,
    height: '100%',
  },
  calendarStyling: {
    fontSize: '13px',
    height: 408,
  },
});

export default function DashboardUpcomingCalendar(props: DashboardUpcomingCalendarProps) {
  const { soonestDueDocuments, loading, calendarRef, iCalendar } = props;
  const classes = useStyles();

  const projectId = useSelector(getProjectId)!;

  const [projectEvents, setProjectEvents] = useState<IProjectCalendarEvent[]>([]);

  useEffect(() => {
    if (projectId) getAllProjectCalendarEvents(projectId).then(setProjectEvents);
  }, [projectId]);

  return (
    <div className={classes.root}>
      <MonthDayCalendar
        soonestDueDocuments={soonestDueDocuments}
        projectEvents={projectEvents}
        loading={loading}
        calendarRef={calendarRef}
        iCalendar={iCalendar}
        views={{ week: true }}
        defaultView="week"
        calendarContainerClassName={classes.calendarStyling}
      />
    </div>
  );
}
